<template>
    <v-col class="py-0 co-campo-pesquisa-modelo">
        <v-text-field
            class="pa-0 input-busca"
            v-model="filtros.titulo.value"
            name="BuscarPor"
            :placeholder="placeHolderPesquisalabel"
            persistent-placeholder
            hide-details
            v-on:blur="filtrar"
            v-on:keyup.enter="filtrar"
        >
            <template #append>
                <v-btn icon @click="filtrar">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">
                                mdi-magnify
                            </v-icon>
                        </template>
                        <span>Pesquisar</span>
                    </v-tooltip>
                </v-btn>

                <v-btn icon @click="limpar">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">
                                mdi-close
                            </v-icon>
                        </template>
                        <span>Limpar filtros</span>
                    </v-tooltip>
                </v-btn>
            </template>
        </v-text-field>
    </v-col>
</template>

<script>

export default {
    name: 'CampoPesquisaModelo',
    props: {
        filtros: {
            type: Object,
            required: true
        }
    },
    computed: {
        placeHolderPesquisalabel() {
            return `Buscar por modelos`
        }
    },
    methods: {
        filtrar() {
            if (!this.filtros.titulo.value) return
            this.$emit('filtrar')
        },
        limpar() {
            this.filtros.titulo.value = ''
            this.$emit('filtrar')
        }
    }
}
</script>

<style lang="stylus">
.co-campo-pesquisa-modelo
    padding 0
    width 100%
    max-width 500px

    .input-busca
        input
            text-overflow ellipsis

    .v-select__selections
        width 100px

    .v-input__slot
        margin-bottom 0

    .append-pesquisa
        display inline-flex

</style>
